import React, { useState, useEffect } from "react";
import "./index.less";
import { getUserAlias } from "@/utils/chat/group";
import { Session } from "@/types/chat";

interface ComGroupAliasProps {
  wrapClassName?: string;
  user: any;
  session: Session;
  keyword?: string;
  hideRemark?: boolean;
  hideAlias?: boolean;
}

type IProps = Readonly<ComGroupAliasProps>;
function ComGroupAlias(props: IProps) {
  const { wrapClassName, user, session, keyword, hideRemark, hideAlias } = props;
  // const { groupRosters } = React.useContext(Context);
  const [alias, setAlias] = useState("");

  useEffect(() => {
    const alias = getUserAlias(user, session, hideRemark ? "hideRemark" : "");
    let highAlias = alias;
    if (keyword?.length) {
      let replaceReg = new RegExp(keyword, "g");
      let replaceString = '<span class="highlight-text">' + keyword + "</span>";
      highAlias = highAlias.replace(replaceReg, replaceString);
    } else {
      highAlias = alias;
    }
    setAlias(highAlias);
  }, [user, session, keyword, hideRemark]);

  if (!alias) {
    return null;
  }
  return (
    <div className={`com-alias-wrapper ${wrapClassName ? wrapClassName : ""}`}>
      <div>（</div>
      <div className="com-alias-wrapper_alias" dangerouslySetInnerHTML={{ __html: `${alias}` }} />
      <div>）</div>
    </div>
  );
}

export default ComGroupAlias;
